<template>
  <div
    :title="itemData.title"
    class="element_card block w-full cursor-pointer overflow-hidden rounded shadow-normal shadow-gray-400 hover:shadow-blue-400/50 tablet:flex"
    @click="handleClick"
  >
    <div
      class="flex w-full flex-col justify-between p-3 tablet:h-80 tablet:w-6/12 tablet:p-5"
    >
      <div class="flex-1">
        <h3
          class="mb-2 flex-1 text-base font-bold tablet:line-clamp-3 tablet:max-h-[5.25rem] tablet:text-lg desktop:line-clamp-2 desktop:max-h-14"
        >
          {{ itemData.title }}
        </h3>
        <p
          class="mb-4 text-sm text-gray-600 tablet:mb-0 tablet:line-clamp-5 tablet:max-h-[6.25rem] tablet:text-base desktop:line-clamp-4 desktop:max-h-24"
        >
          {{ itemData.description }}
        </p>
      </div>
      <div class="hidden justify-end tablet:flex">
        <TheNuxtLink
          :to="itemData.pageUrl"
          :title="itemData.title"
          class="element_arrow flex h-8 w-8 basis-8 items-center justify-center rounded text-blue-400"
        >
          <IconArrow class="h-5 w-5" direction="right" />
        </TheNuxtLink>
      </div>
    </div>
    <div
      class="relative min-h-[200px] w-full overflow-hidden tablet:h-80 tablet:min-h-0 tablet:w-6/12"
    >
      <figure class="absolute left-0 top-0 h-full w-full overflow-hidden">
        <img
          :src="itemData.imageUrl"
          :alt="itemData.title"
          loading="lazy"
          class="pointer-events-none absolute left-0 top-0 block h-full w-full object-cover"
        />
      </figure>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { IResource } from '@/assets/types/api/Products';

  interface IProps {
    itemData: IResource;
  }

  const props = withDefaults(defineProps<IProps>(), {
    itemData: () => ({
      title: '',
      description: '',
      pageUrl: '',
      imageUrl: '',
      releaseDate: '',
    }),
  });

  const router = useRouter();

  const handleClick = (): void => {
    router.push(props.itemData.pageUrl);
  };
</script>

<style lang="scss" scoped>
  .element_card:hover {
    .element_arrow {
      @apply bg-blue-400 text-white;
    }
  }
</style>
